import React from 'react'
import { Link } from 'react-router'

import { Details, Title, Message, DarkBlueBadge, LightBlueBadge, TealBadge, RedBadge } from '../data-card/data-card-parts'
import { DataCard, MessageWithPrefix, TimeFrame } from '../data-card/data-card-parts'

export default ({
  id,
  area,
  servicingId,
  workOrderId,
  servicesString,
  highPriority,
  hasBeforeAfters,
  beforeImage,
  afterImage,
  redoReason,
  inspectionImageA = {},
  inspectionImageB = {},
  unableReason,
  completedAt,
  previousCompletedAt,
  createdAt,
  technician,
  requestor,
  status,
  approvalStatus,
}) => {
  let highPriorityBadge = null
  let redoneBadge = null
  let redoMessage = null
  let completionMessage = null
  let originalCompletionMessage = null
  let inspectionMessage = null
  let viewImagesBadge = null
  let inspectionImagesBadge = null

  if (highPriority) {
    highPriorityBadge = <RedBadge text='high priority' />
  }

  if (redoReason) {
    redoneBadge = <RedBadge text='redo' />
    redoMessage = <MessageWithPrefix key="redo-reason" prefix="Redo reason: " text={redoReason} />
  }

  //sls:
  if (typeof (beforeAfters) == "object" && typeof (afterImage) == "object") {

    console.log("-----------");
    console.log(typeof (beforeAfters));
    console.log(beforeAfters);

    if (beforeImage.url || afterImage.url || hasBeforeAfters) {


      viewImagesBadge = <Link to={`/summaries/${workOrderId}/${servicingId}/images`}>
        <TealBadge right text="View Images" />
      </Link>
    }
  }

  if (inspectionImageA.url || inspectionImageB.url) {
    inspectionImagesBadge = <Link to={`/summaries/${workOrderId}/${servicingId}/redo_images`}>
      <RedBadge additionalClasses="right" text="Inspection Images" />
    </Link>
  }

  if (createdAt) {
    inspectionMessage =
      <p className='timestamp'>{`Inspected on ${createdAt.format('MMMM D, YYYY h:mmA')} by ${requestor.name}`}</p>
  }

  return (
    <div className="servicing-summary separated" style={{ backgroundColor: 'rgba(255,255,255,0.83)' }}>
      <div className='details'>
        <div>
          <LightBlueBadge text={workOrderId.toString()} />
          <strong>{area.name}</strong>
        </div>
        {highPriorityBadge}
        {redoneBadge}
        {viewImagesBadge}
        {inspectionImagesBadge}

        <div className='services'>
          {servicesString}
        </div>

        <p className='timestamp'>{formatCompletion({ status, completedAt, previousCompletedAt, technician })}</p>
        {inspectionMessage}
        {formatReason({ unableReason, redoReason })}
      </div>

      <div className='controls'>
        {servicingStatusImage(approvalStatus)}
      </div>
    </div>
  )
}

function servicingStatusImage(approvalStatus) {
  const imageName = {
    approved: 'completed',
    denied: 'cant-complete',
    rescheduled: 'rescheduled',
  }[approvalStatus]

  if (!imageName) return null

  return (
    <img src={require(`../../images/task-${imageName}-selected.svg`)} />
  )
}

function formatCompletion({ completedAt, previousCompletedAt, status, technician }) {
  const date = completedAt ? completedAt : previousCompletedAt

  if (!date) return 'Yet to be completed.'

  var base = {
    completed: 'Completed on',
    unable: 'Marked unable to complete on',
    permanently_occupied: 'Marked permanently occupied on',
    open: 'Originally completed on'
  }[status]

  base += ` ${date.format('MMMM D, YYYY [at] h:mm A')} by ${technician.name}`

  return base
}

function formatReason({ unableReason, redoReason }) {
  if (unableReason && unableReason.length > 0) {
    return <p className='timestamp'>Unable to complete reason: {unableReason}</p>
  }

  if (redoReason && redoReason.length > 0) {
    return <p className='timestamp'>Redo reason: {redoReason}</p>
  }
}



// WEBPACK FOOTER //
// ./src/components/inspections/inspection-card.js